import React from 'react';
import { Container, Spinner } from 'react-bootstrap';

function FetchContainer({ error, fetchingData, children, minHeight, fluid, absolute, className }) {
  let content = children;

  if (error) {
    content = <span>{error}</span>
  }

  if (fetchingData) {
    content = (
      <div 
        className='d-flex h-100 flex-column justify-content-center'
        style={{
          ...minHeight && ({ minHeight: minHeight })
        }}
      >
        <div
          className='d-flex justify-content-center'
          style={{
            ...absolute && ({
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translateX(-50%)'
            })
          }}
        >
          <div>
            <Spinner variant='primary' animation='border' />
          </div>
        </div>
      </div>
    )
  }

  return (
    <Container 
      // className={absolute && 'min-vh-100'} 
      // className={className}
      fluid={fluid}
    >
      { content }
    </Container>
  );
}

export default FetchContainer;